var React = require('react');

function Right (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2 90h22c1.11 0 2 0.9 2 2v22c0 1.11-0.89 2-2 2H2c-1.1 0-2-0.89-2-2V92C0 90.9 0.9 90 2 90z","fill":"#757575","key":0}),React.createElement("path",{"d":"M14.96 98.07l-0.64 0.64 3.6 3.6 -11.84 0 0 0.93h11.93l-3.69 3.69 0.64 0.64 4.75-4.75L14.96 98.07z","style":{"fill":"#FFF","strokeMiterlimit":"10","strokeWidth":"2","stroke":"#FFF"},"key":1})]);
}

Right.defaultProps = {"width":"37.11","height":"26.64","viewBox":"-0.31 89.69 37.11 26.64","style":{"enableBackground":"new -0.306 89.694 37.107 26.635","version":"1"}};

module.exports = Right;

Right.default = Right;
